import * as React from 'react';
import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import { IconButton, useTheme } from '@mui/material';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// MUI Icons
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

// Custom components
import SidebarContext, { SidebarContextType } from './SidebarContext/SidebarContext';

// Types

const SidebarHeading: FunctionComponent = () => {
  const sidebarContext = useContext(SidebarContext) as SidebarContextType;

  const theme = useTheme();

  const { t } = useTranslation();

  const title = sidebarContext?.sidebarHeading as string;
  const onCollapse = sidebarContext?.onSidebarCollapse;

  const handleCollapse = (): void => {
    sidebarContext.setCollapsed(true);
    if (onCollapse) {
      onCollapse();
    }
  };

  const isCollapsed = sidebarContext.collapsed;
  const isLeft = sidebarContext.position === "left";
  // const isRight = sidebarContext.position === "right";

  return (
    <Stack
      direction="column"
      sx={{
        height: 40,
        display: isCollapsed ? "none" : "block",
        backgroundColor: theme.palette.primary.main,
        transition: "width 500ms"
      }}
      color="white"
    >
      <Typography
        variant="h6"
        component="h1"
        style={{ color: "white" }}
        sx={{
          width: "calc(100% - 60px)",
          pl: "12px",
          py: "4px"
        }}

      // style={{
      //   backgroundColor: theme.palette.primary.main,
      //   margin: '0',
      //   height: 40,
      //   padding: '0 20px',
      //   paddingLeft: isRight ? 40 : 20,
      //   lineHeight: '40px',
      //   fontSize: '14.4pt',
      //   color: '#fff',
      //   position: 'absolute'
      // }}
      >
        {t(title)}
      </Typography>
      <IconButton onClick={handleCollapse}
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          color:"white"
        }}>
        {isLeft ? <ArrowLeftIcon /> : <ArrowRightIcon />}
      </IconButton>

    </Stack>
  );
};

export default SidebarHeading;
